import React from "react";
import { useParams } from "react-router-dom";
import JuzDelights from "./projectDetails/JuzDelights/JuzDelgihts";
import Collide from "./projectDetails/Collide/Collide";
import MovieMates from "./projectDetails/MovieMates/MovieMates";
import TsengLab from "./projectDetails/TsengLab";
import StudentHub from "./projectDetails/StudentHub/StudentHub";
import NeighborhoodNav from "./projectDetails/Neighborhood/Neighborhood";
import Armoire from "./projectDetails/Armoire/Armoire";
import Snapper from "./projectDetails/Snapper/Snapper.js";
import Footer from "../Footer/footer.js";

const projects = [
  { id: "Snapper", component: Snapper },
  { id: "Armoire", component: Armoire },
  { id: "JuzDelights", component: JuzDelights },
  { id: "Collide", component: Collide },
  { id: "MovieMates", component: MovieMates },
  { id: "TsengLab", component: TsengLab },
  { id: "StudentHub", component: StudentHub },
  { id: "NeighborhoodNav", component: NeighborhoodNav },
];

function ProjectPage() {
  const { id } = useParams();
  const project = projects.find((p) => p.id === id);

  if (!project) {
    return (
      <div className="project-page">
        <div className="project-container">
          <h1>Project not found</h1>
          <p>The project you're looking for doesn't exist.</p>
        </div>
      </div>
    );
  }

  const ProjectComponent = project.component;
  
  return (
    <div>
      <div className="project-page">
        <ProjectComponent />
      </div>
      <Footer />
    </div>
  );
}

export default ProjectPage;
